import { render } from "./header-auth.vue?vue&type=template&id=9f2323ca&ts=true"
import script from "./header-auth.vue?vue&type=script&lang=ts"
export * from "./header-auth.vue?vue&type=script&lang=ts"

import "./header-auth.vue?vue&type=style&index=0&id=9f2323ca&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__